var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-toolbar',{attrs:{"light":""}},[_c('v-toolbar-title',[_vm._v("Title")]),_c('v-spacer'),_vm._l((_vm.items),function(item){return _c('v-toolbar-items',{key:item.text,staticClass:"hidden-sm-and-down"},[_c('v-btn',{attrs:{"text":""}},[_vm._v(_vm._s(item.text))])],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }